var $1704ee735c76afc9$exports = {};
$1704ee735c76afc9$exports = {
    "alert": `\u{395}\u{3B9}\u{3B4}\u{3BF}\u{3C0}\u{3BF}\u{3AF}\u{3B7}\u{3C3}\u{3B7}`,
    "dismiss": `\u{391}\u{3C0}\u{3CC}\u{3C1}\u{3C1}\u{3B9}\u{3C8}\u{3B7}`
};


export {$1704ee735c76afc9$exports as default};
//# sourceMappingURL=el-GR.module.js.map
